<template>
    <div>
        <div class="main-container">
          <pop-up-message
            v-if="showSuccessMsg"
            :message="`Client account details has been successfully created`"
            btnText="Back"
            @back="backFromPopUp()"
          />
          <toast-message
              :message="errmsg"
              type="error"
              :isToastEnable="toast"
              @close="(val) => (toast = val)"
            />
            <div style="display: flex;">
              <img class="logoimg" src="@/assets/dashboard/HSBC_MASTER_LOGO.svg">
            <tl-header type="h3" class="head"></tl-header>
            </div>
           
       <div class="headerField">
        <txt
            label="Client Name*"
            type="text"
            v-model="formData.clientName"
            name="userDefinedField"
            data-vv-as="user defined"
            v-validate="'required'"
            :classname="errors.has('userDefinedField')"
            :errormsg="errors.first('userDefinedField')"
          />
          <txt
            label="Legal Entity ID*"
            type="text"
            v-model="formData.legalEntityId"
            name="legalEntityID"
            data-vv-as="legal_Entity_ID"
            v-validate="'required'"
            :classname="errors.has('legalEntityID')"
            :errormsg="errors.first('legalEntityID')"
          />
       </div>
       <div class="headerField">
        <txt
            label="Bank Name"
            type="text"
            v-model="formData.bankName"
            name="Bank Name"
          />
          <txt
            label="Account Name"
            type="text"
            v-model="formData.bankAccountName"
            name="userDefinedField"
          />
          <txt
            label="Account Number"
            type="text"
            v-model="formData.bankAccountNumber"
            name="Account_number"
            data-vv-as="Account_number "
            v-validate="'required || numeric'"
            :classname="errors.has('Account_number')"
            :errormsg="errors.first('Account_number')"
          />
       </div>
       <div class="headerField">
        <txt
            label="Bank IFSC Code"
            type="text"
            v-model="formData.bankIFSCCode"
            name="IFSC_Code"
            data-vv-as="IFSC_Code "
            v-validate="{required: true, regex:ifscRegex, length:11}"
            :classname="errors.has('IFSC_Code')"
            :errormsg="errors.first('IFSC_Code')"
          />
          <txt
            label="Branch Name*"
            type="text"
            v-model="formData.bankBranchName"
            name="userDefinedField"
          />
          <txt
            label="Bank Address"
            type="text"
            v-model="formData.bankAddress[0].building"
            name="userDefinedField"
          />
       </div>
       <div class="headerField">
        <txt
            label="HSBC ID*"
            type="text"
            v-model="formData.HSBCId"
            name="HSBC_ID"
            data-vv-as="HSBC ID "
            v-validate="'required'"
            :classname="errors.has('HSBC_ID')"
            :errormsg="errors.first('HSBC_ID')"
          />
       </div>
       <footer>
          <bottom-action-container>
            <template slot="end">
              <btn-grp class="form-button">
                <btn
                  text="Reset"
                  type="secondary"
                  @click="resetFuction"
                />
                <btn
                  text="Save"
                  type="primary"
                  @click="createHsbcPaymentSetting"
                />
              </btn-grp>
            </template>
          </bottom-action-container>
        </footer>
    </div>
    </div>
</template>
<script>
import { mapActions } from 'vuex';
import * as globalConfig from "@/apis/config.js";
export default{
    data(){
        return{
          showSuccessMsg:false, 
          toast:false,
          errmsg:"",
          ifscRegex:null,
         formData:{
              clientShortName:"anil",
              clientName:"",
              legalEntityId:"",
              bankName:"",
              bankAccountName:"",
              bankAccountNumber:"",
              bankIFSCCode:"",
              bankBranchName:"",
              bankAddress: [{
                   building: ""
                   }],
              HSBCId: ""
             }
        }
    },
    mounted(){
      this.ifscRegex = globalConfig.Regex.IFSC;
    },
    methods: {
      ...mapActions({
        act_hsbc_payment_setting:"dashboard/hsbcPaymentSetting/createHsbcSetting"
      }),
      backFromPopUp() {
      this.showSuccessMsg = false;
    },
      resetFuction(){
        this.formData={
              clientShortName:"anil",
              clientName:"",
              legalEntityId:"",
              bankName:"",
              bankAccountName:"",
              bankAccountNumber:"",
              bankIFSCCode:"",
              bankBranchName:"",
              bankAddress: [{
                   building: ""
                   }],
              HSBCId: ""
             }
      },
     async createHsbcPaymentSetting(){
        try{
              if((this.formData.clientName || this.formData.bankIFSCCode || this.formData.HSBCId || this.formData.bankAccountNumber)!== ""){
                let res= await this.act_hsbc_payment_setting(this.formData)
              if(res.data.success == true){
               this. showSuccessMsg=true
              }
              }
              else{
                this.errmsg = "Please fill mandatory field"
                this.toast = true
              }
            
        }catch(err){

        }
      }
    },
}
</script>
<style lang="scss" scoped>
 .headerField{
    display: flex;
    gap: 12rem;
    margin-bottom: 60px;
    
 }
 .head{
    margin-bottom: 20px;
 }
 .logoimg{
  height: 80px;
  width: 120px;
  padding-right: 2px;
}

</style>